define([
	"dojo/_base/declare",
	"underscore",
	"csi",
	"csi/_base/storage",
	"csi/xml",
	"csi/xml/Query",
	"SiteAdmin/DataSheetTable"
], function(declare, _, csi, storage, xml, Query, DataSheetTable) {

	const STORAGE_KEY = "ProductSalesRegionURLS";

	return declare(DataSheetTable, {
		/** @property {reflist} activeProductSalesRegions - product sales regions to use to filter list of Items to display. Default empty = All will be displayed */
		activeProductSalesRegions: null,

		/**
		 *  @override
		 *  If Sales Region Selector is not empty, display only selected Sales Region
		 */
		onBuildColumns: function(ctx, dfds) {
			const store = this.get("store");
			if (!store) {
				return;
			}

			if (!_.isEmpty(this.activeProductSalesRegions)) {
				const q = new Query();

				_.each(this.activeProductSalesRegions, function(region) {
					this.Node(xml.PROP_URL, xml.OP_EQUALS, region);
				}, q.Or());

				if (!q.isEmpty()) {
					store.filterQuery = q;
				}
			}
		},

		/**
		 * @override
		 * Set the store per selected SalesRegions
		 */
		onViewCreate: function() {
			this.set("activeProductSalesRegions", storage.get(STORAGE_KEY));

			this.watch("activeProductSalesRegions", function(name, oldValue, newValue) {
				storage.set(STORAGE_KEY, newValue);
			});

			this.inherited(arguments);
		}

	});
});